<!-- cv page -->
<template>
  <div data-app>
    <div class="row">
      <div class="col-md-12">
      </div>

      <div class="col-md-12 pt-0">
        <div class="row m-0 col-12 pb-3 bg-white border-r-16 pt-4">
          <div class="col-md-4 p-0">
            <span class="leatext_job_heading_by_new_home">Manage your CV</span>
          </div>
          <div class="
            col-md-8
            p-0
            row
            m-0
            d-flex
            justify-content-end
            new_list_st_by_ch
          ">
            <button type="button" class="text-center custom-add-new-record-button btn_dash_ch___ mr-2" fab small
              @click="createFormEnable">
              Add new CV

            </button>
          </div>
        </div>
        <div class="col-md-12 row p-0 m-0">

          <div data-app class="p-0">
            <div class="row mt-1 mx-0 new_list_st_by_ch">
              <div class="row m-0 col-8 py-0 pl-0" style="height: fit-content">

                <div class="empty_div_jobsAdd" v-if="
                  data.length == 0
                ">
                  You have not created any CVs yet
                </div>
                <div class="col-md-4 row m-0 mt-4 pt-0 pr-0" v-for="(item, index) in data.filter(
                (item) => item.archive == '0')" :key="index" :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''">
                  <div class="col-md-12 row m-0 border-r-16 p-4" :class="
                    cvId && cvId === item.id
                      ? 'bg-info-new'
                      : 'bg-white'
                  ">
                    <div class="col-md-12 p-0">
                      <h4 class="mb-0" style="
                          color: #242424;
                          font-size: 18px;
                          font-weight: bold;
                        ">
                        {{ item.cv_title }}
                      </h4>
                    </div>
                    <div class="col-md-12 p-0 pb-2 pt-4">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4 class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          ">
                          <img src="/images/job_page/Date_posted.svg" alt="..." class="pr-4" /><span
                            class="tooltiptextch">Date Added</span>
                        </h4>
                        <span>{{
                        moment(item.created_at).format("DD MMMM, YYYY hh:mm A")
                        }}</span>
                      </div>
                    </div>
                    <hr class="col-md-12 p-0 mt-4 mb-0" style="background: rgba(53, 162, 229, 0.25)" />
                    <div class="col-md-12 p-0 pb-2 pt-4 row m-0">
                      <div class="col-6 p-0" style="font-size: 16px;color: #005696;font-weight: bold;">Default</div>
                      <div class="col-6 p-0 text-end">
                        <toggle-button :value="item.default == '' + 1 ? true : false" color="#82C7EB" :sync="true"
                          :labels="false" class="pl-4" @change="changeStatus(item)" />
                      </div>

                    </div>
                    <hr class="col-md-12 p-0 mt-0" style="background: rgba(53, 162, 229, 0.25)" />
                    <div class="_btn_gridddd_add_jon _btn_gridddd p-0 m-0">
                      <div class="p-0" @click="viewButtonClick(item.path)">
                        <button type="button" class="new_details_job_dashbord_list2 back_fill_job">
                          View CV DOCs
                        </button>
                      </div>
                      <div class="p-0" style="">
                        <button type="button" class="new_details_job_dashbord_list2">
                          <div @contextmenu="handler($event)" @click="editButtonClick(item)">
                            <span class="v-btn__content">Edit</span>
                          </div>
                        </button>
                      </div>
                      <div class="p-0" style="position: relative" @click="CVArchive(item)">
                        <button type="button" class="
                            new_details_job_dashbord_list2
                            tooltipch
                            archive_buton
                          ">
                          <img class="dashbord" src="\images/job_page/archive.png" alt="" width="16" height="16" />
                          <span class="tooltiptextch gray">Archive CV</span>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
                <hr class="col-md-12 p-0 mt-4" style="background: rgba(53, 162, 229, 0.25)" />
                <div class="row m-0 col-12 pb-3 bg-white border-r-16 pt-4">
                  <div class="col-md-4 p-0">
                    <span class="leatext_job_heading_by_new_home">Archive CVs</span>
                  </div>
                  <div class="
                    col-md-8
                    p-0
                    row
                    m-0
                    d-flex
                    justify-content-end
                    new_list_st_by_ch
                  ">

                  </div>
                </div>
                <div class="empty_div_jobsAdd" v-if="
                  data.filter(
                (item) => item.archive == '1').length == 0
                ">
                  No archived CVs
                </div>
                <div class="col-md-4 row m-0 mt-4 pt-0 pr-0" v-for="(item, index) in data.filter(
                (item) => item.archive == '1')" :key="index" :class="index == 0 || index % 3 == 0 ? 'pl-0' : ''">
                  <div class="col-md-12 row m-0 border-r-16 p-4" :class="
                    cvId && cvId === item.id
                      ? 'bg-info-new'
                      : 'archive_dark'
                  ">
                    <div class="col-md-12 p-0">
                      <h4 class="mb-0" style="
                          color: #242424;
                          font-size: 18px;
                          font-weight: bold;
                        ">
                        {{ item.cv_title }}
                      </h4>
                    </div>
                    <div class="col-md-12 p-0 pb-2 pt-4">
                      <div class="m-0" style="color: #666; font-size: 14px">
                        <h4 class="
                            widget-title
                            tooltipch
                            mb-0
                            bold
                            detail_heading
                          ">
                          <img src="/images/job_page/dark_exp.svg" alt="..." class="pr-4" /><span
                            class="tooltiptextch">Date Added</span>
                        </h4>
                        <span>{{
                        moment(item.created_at).format("DD MMMM, YYYY hh:mm A")
                        }}</span>
                      </div>
                    </div>
                    <hr class="col-md-12 p-0 mt-4 mb-0" style="background: rgba(53, 162, 229, 0.25)" />
                    <div class="col-md-12 p-0 pb-2 pt-4 row m-0">
                      <div class="col-6 p-0" style="color: rgb(36, 36, 36); font-size: 18px; font-weight: bold;">Default
                      </div>
                      <div class="col-6 p-0 text-end">
                        <toggle-button aria-disabled="disabled" disabled :value="item.default == '' + 1 ? true : false"
                          color="#82C7EB" :sync="true" :labels="false" class="pl-4" @change="changeStatus(item)" />
                      </div>

                    </div>
                    <hr class="col-md-12 p-0 mt-0" style="background: rgba(53, 162, 229, 0.25)" />
                    <div class="_btn_gridddd_add_jon _btn_gridddd p-0 m-0">
                      <div class="p-0" @click="viewButtonClick(item.path)">
                        <button type="button" class="new_details_job_dashbord_list2 back_fill_job_dark">
                          View CV DOCs
                        </button>
                      </div>
                      <div class="p-0" style="">
                        <button type="button"
                          class="new_details_job_dashbord_list2 new_details_job_dashbord_list2_dark">
                          <div @contextmenu="handler($event)" @click="editButtonClick(item)">
                            <span class="v-btn__content">Edit</span>
                          </div>
                        </button>
                      </div>
                      <div class="p-0" style="position: relative" @click="CVArchive(item)">
                        <button type="button" class="
                            new_details_job_dashbord_list2
                            tooltipch
                            archive_buton
                          ">
                          <img class="dashbord" src="\images/job_page/archive.png" alt="" width="16" height="16" />
                          <span class="tooltiptextch gray">Archive CV</span>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-lg-4 p-0 alwyes sidbar_ch_new3" v-if="alwyes">
                <div class="col-lg-12 pl-0 pr-0 pt-4">
                  <div class="card sidebar">
                    <div class="card-body widget cardbodych" style="">
                      <h5 class="" style="
                              font-style: normal;
                              font-weight: 700 !important;
                              font-size: 30px;
                              line-height: 120%;
                              color: #005696;
                            ">
                        Advertise with <br />
                        job4u.pk
                      </h5>
                    </div>
                    <div class="col-12">
                      <p style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 140%;
                        color: #666666;
                        background: transparent !important;
                      ">
                        Contact us to display your
                        Ad here to reach tens of
                        thousands of people!

                      </p>
                      <button style="
                              padding: 12px 16px;
                              gap: 8px;
                              background: #35a2e5;
                              border-radius: 53px;
                              font-style: normal;
                              font-weight: 400;
                              font-size: 16px;
                              line-height: 140%;
                              color: #ffffff;
                            ">
                        <img class="dashbord123" src="\images/job_application/Call.svg" alt=""
                          style="margin-right: 10px" />
                        Contact Sales
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 p-0 sidbar_ch_new3 mt-4" v-if="createForm || updateForm">
                <v-card class="border-t-lr-16 bg-info-new" v-if="createForm">
                  <div style="padding: 3%">
                    <div class="row m-0 p-0">
                      <div class="col-md-12 p-0 text-end" style="z-index: 1;">
                        <button class="badge badge-danger badge-pill" @click="cancel()">
                          X
                        </button>
                      </div>
                      <div style="position: relative;font-weight: 600;font-size: 21px;color: #005696;position: relative"
                        class="col-md-4 p-0 margin_nagtive mb-4">
                        Add New CV
                      </div>
                    </div>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <div class="row">
                        <div class="col-md-12 py-0 input_label_s_ch">
                          <label for="CVtitle" class="pt-4">CV title</label>
                          <v-text-field v-model="cvTitle" :rules="nameRules" required></v-text-field>
                        </div>

                        <div class="col-md-12 py-0 input_label_s_ch2 ">
                          <label for="Choose your CV">Choose your CV</label>
                          <v-file-input v-model="cvFile" accept="image/pdf, image/docx, .pdf , .docx">
                          </v-file-input>
                        </div>
                        <div class="col-md-12 pt-0 pb-0 input_label_s_ch22">
                          <label>Note: Please Upload PDF or Doc File. It Should not be
                            larger than 3 MB in size.</label>
                        </div>
                        <div class="col-md-6 pt-0 pb-0 input_label_s_ch222">
                          <b-form-select v-model="introVideo" :options="introVideosOptions" size="sm" class="mt-3"
                            required>
                          </b-form-select>
                        </div>
                        <div class="col-md-6 pt-0 pl-0 pb-0 input_label_s_ch222">
                          <b-form-select v-model="introAudio" :options="introAudiosOptions" size="sm" class="mt-3"
                            required>
                          </b-form-select>
                        </div>
                      </div>
                      <div class="row" style="margin-top: 2%">
                        <div class="col-md-12 input_label_s_ch input_label_s_ch_txtera pb-0">
                          <label for="Cover letter" class="pt-4">Cover letter</label>
                          <v-textarea class="m-0" v-model="coverLetter" outlined name="input-7-4" rows="3">
                          </v-textarea>
                        </div>
                        <div class="col-md-12 input_label_s_ch input_label_s_ch_txtera py-0">
                          <label for="Internel notes" class="pt-4">Internel notes</label>
                          <v-textarea v-model="internelNotes" outlined name="input-7-4" rows="3">
                          </v-textarea>
                        </div>
                      </div>

                      <div class="row" style="margin-top: 2rem">

                        <div class="col-md-6 button_by_save_cv_ch">
                          <v-btn class="
                            btn btn-sm btn-success
                            font-weight-bold
                          " @click="createCV" :disabled="
                            cvTitle === '' ||
                            (cvTitle === null && cvFile === '') ||
                            cvFile === null
                              ? true
                              : false
                          ">
                            <b-spinner small type="grow" v-if="submitting"></b-spinner>
                            Save
                          </v-btn>
                        </div>
                        <div class="col-md-6 button_by_cencl_cv_ch">
                          <v-btn class="
                            btn btn-sm btn-danger
                            font-weight-bold
                          " @click="cancel">
                            Cancel
                          </v-btn>
                        </div>
                      </div>

                    </v-form>
                  </div>
                </v-card>
                <v-card class="border-t-lr-16 bg-info-new ch_tabs_for_cv_aop" v-if="updateForm">
                  <b-card no-body>
                    <b-tabs pills card>
                      <b-tab title="Edit CV" active>
                        <b-card-text>
                          <div style="padding: 3%">
                            <div class="row m-0 p-0">
                              <div class="col-md-12 p-0 text-end" style="position: absolute;right: 6px;top: 23px;">
                                <button class="badge badge-danger badge-pill" @click="cancel()">
                                  X
                                </button>
                              </div>
                            </div>
                            <v-form ref="form" v-model="valid" lazy-validation>
                              <div class="row">

                                <div class="col-md-12 py-0 input_label_s_ch">
                                  <label for="CVtitle" class="pt-4">CV title</label>
                                  <v-text-field v-model="cvTitle" :rules="nameRules" required></v-text-field>
                                </div>

                                <div class="col-md-12 py-0 input_label_s_ch2 ">
                                  <label for="Choose your CV">Choose your CV</label>
                                  <v-file-input v-model="cvFile" accept="image/pdf, image/docx, .pdf , .docx">
                                  </v-file-input>
                                </div>
                                <div class="col-md-12 pt-0 pb-0 input_label_s_ch22">
                                  <label>Note: Please Upload PDF or Doc File. It Should not be
                                    larger than 3 MB in size.</label>
                                </div>

                                <div class="col-md-6 pt-0 pb-0 input_label_s_ch222">
                                  <b-form-select v-model="introVideo" :options="introVideosOptions" size="sm"
                                    class="mt-3" required>
                                  </b-form-select>
                                </div>

                                <div class="col-md-6 pt-0 pl-0 pb-0 input_label_s_ch222">
                                  <b-form-select v-model="introAudio" :options="introAudiosOptions" size="sm"
                                    class="mt-3" required>
                                  </b-form-select>
                                </div>
                              </div>
                              <div class="row" style="margin-top: 2%">
                                <div class="col-md-12 input_label_s_ch input_label_s_ch_txtera pb-0">
                                  <label for="Cover letter" class="pt-4">Cover letter</label>
                                  <v-textarea class="m-0" v-model="coverLetter" outlined name="input-7-4" rows="3">
                                  </v-textarea>
                                </div>
                                <div class="col-md-12 input_label_s_ch input_label_s_ch_txtera py-0">
                                  <label for="Internel notes" class="pt-4">Internel notes</label>
                                  <v-textarea v-model="internelNotes" outlined name="input-7-4" rows="3">
                                  </v-textarea>
                                </div>
                              </div>
                              <div class="row" style="margin-top: 2rem">

                                <div class="col-md-6 button_by_save_cv_ch">
                                  <v-btn class="
                            btn btn-sm btn-success
                            font-weight-bold
                              " @click="updateCV" :disabled="
                                cvTitle === '' ||
                                (cvTitle === null && cvFile === '') ||
                                cvFile === null
                                  ? true
                                  : false
                              ">
                                    <b-spinner small type="grow" v-if="submitting"></b-spinner>
                                    Update
                                  </v-btn>
                                </div>
                                <div class="col-md-6 button_by_cencl_cv_ch">
                                  <v-btn class="
                            btn btn-sm btn-danger
                            font-weight-bold
                        " @click="cancel">
                                    Cancel
                                  </v-btn>
                                </div>
                              </div>

                            </v-form>
                          </div>
                        </b-card-text>
                      </b-tab>
                      <b-tab title="View Application">
                        <b-card-text>
                          <div style="padding: 3%">
                            <div class="row m-0 p-0" style="position: absolute;right: 6px;top: 23px;">
                              <div class="col-md-12 p-0 text-end" style="z-index: 1;">
                                <button class="badge badge-danger badge-pill" @click="cancel()">
                                  X
                                </button>
                              </div>
                            </div>
                            <!-- ???????????????????????????????????????? -->
                            <div class="row m-0 mb-4"  v-for="(item, index) in cV_APP.job_applications" :key="index">
                              <!-- <div > -->
                                <div class="pic_border m-0 circular--portrait col-md-2 p-0" >
                                  <span class="">
                                    <span class="svg-icon svg-icon-lg " >
                                      <router-link :to="
                                        '/employer/' +
                                        item.recruiter.company_name
                                            .toLowerCase()
                                            .replace(/ /g, '-') +
                                          '/' +
                                          item.recruiter.id
                                      " target="_blank">
                                        <img @error="onImageLoadFailure($event)" :src="mediaUrl + item.recruiter.profile_pic || ''"
                                          width="60" height="60" class="p-1" />
                                      </router-link>
                                    </span>
                                  </span>
                                </div>
                                <div class="col-md-8 font-weight-bold pt-2">
                                  <a class="font-weight-bolder Main_Blue mb-1" style="font-size: 14px">
                                    <router-link class="Main_Blue" style="font-size: 14px" :to="
                                      '/employer/' +
                                      item.recruiter.company_name
                                          .toLowerCase()
                                          .replace(/ /g, '-') +
                                        '/' +
                                        item.recruiter.id
                                    " target="_blank">{{ item && item.recruiter.company_name }}</router-link>
                                  </a>
                                  <span style="font-size: 12px; color: rgb(119, 119, 119)">
                                    Applied for {{ item.job_posts.job_title }}
                                  </span>
                                  <span style="font-size: 12px; color: rgb(119, 119, 119)">
                                    Applied: {{ moment(item.created_at).format("DD MMMM, YYYY")}}
                                  </span>
                                </div>
                                <div class="col-md-2 p-0 font-weight-bold" >
                                  <div style="border: 1px solid rgb(53, 162, 229);border-radius: 5px;padding: 4px !important;margin-top: 30%;">
                                    <a href="http://" target="_blank" rel="noopener noreferrer">Deatils</a>
                                  </div>
                                </div>
                              
                              <!-- </div> -->
                            </div>
                            <!-- ???????????????????????????????????????? -->
                          </div>
                        </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </v-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirm Delete Item -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline">Do you really want to DELETE this item?</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false">No</v-btn>
            <v-btn class="custom-cancel-button" text @click="deleteItem">
              <b-spinner small type="grow" v-if="deleting"></b-spinner>Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/core/api";
import { MEDIA_URL } from "@/core/api";
import Swal from "sweetalert2";
import JobSeekerService from "@/MainServices/JobSeekerService.js";
import { VueEditor } from "vue2-editor";
import moment from "moment";

export default {
  data() {
    return {
      MEDIA_URL: MEDIA_URL,
      loading: true,

      relatedCvData: null,
      dialog: false,
      deleteId: null,
      deleting: false,
      success: false,
      submitting: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,
      createForm: false,
      updateForm: false,
      cvTitle: "",
      cvFile: "",
      cvId: null,
      alwyes: true,
      cV_APP:null,
      nameRules: [
        (v) => !!v || "CV title is required",
        (v) =>
          (v && v.length <= 20) || "CV title must be less than 20 characters",
      ],
      headers: [
        { text: "CV Title", value: "cv_title" },
        { text: "Added On", value: "created_at" },
        { text: "SELECT DEFAULT", value: "default" },
        { text: "Action", value: "action" },
      ],
      data: [],
      introVideo: null,
      introVideosOptions: [],
      introAudio: null,
      introAudiosOptions: [],
      internelNotes: "",
      coverLetter: "",

      //testing
      selectedCategory: "none"

    };
  },


  mounted() {
    var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    document.head.appendChild(link);
    this.getInititalData();
  },
  components: {
    VueEditor,
  },
  methods: {
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
    moment: function () {
      return moment();
    },
    getInititalData() {
      JobSeekerService.getMyCvs()
        .then((res) => {
          this.data = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });

      JobSeekerService.getMyVideos()
        .then((_res) => {
          this.introVideosOptions = [];
          this.loading = false;
          _res.data.forEach((element) => {
            this.introVideosOptions.push({
              value: element.id,
              text: element.title,
            });
          });
          this.introVideosOptions.unshift(
            ...[{ value: null, text: "Choose intro video" }]
          );
        })
        .catch(() => {
          this.loading = false;
        });
      // this.introAudiosOptions.unshift(
      //     ...[{ value: null, text: "Choose intro Audio" }]
      //   );
      JobSeekerService.getMyAudios()

        .then((_res) => {
          this.introAudiosOptions = [];
          this.loading = false;
          _res.data.forEach((element) => {
            this.introAudiosOptions.push({
              value: element.id,
              text: element.title,
            });
          });
          this.introAudiosOptions.unshift(
            ...[{ value: null, text: "Choose intro Audio" }]
          );
        })
        .catch(() => {
          this.loading = false;
        });
    },

    cancel() {
      this.dialog = false;
      this.createForm = false;
      this.updateForm = false;
      this.cvTitle = "";
      this.cvFile = "";
      this.loading = false;
      this.success = true;
      this.submitting = false;
      this.introVideo = null;
      this.introAudio = null;
      this.internelNotes = "";
      this.coverLetter = "";
      this.cvId = null;
      this.cV_APP = null;
      this.alwyes = true;
    },
    createFormEnable() {
      this.alwyes = false;
      this.career_level = "";
      this.createForm = true;
      this.updateForm = false;
    },
    createCV() {
      if (this.cvFile == "" || this.cvTitle == "") {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      this.submitting = true;
      let formData = new FormData();
      formData.append("cv_title", this.cvTitle);
      formData.append("cv_file", this.cvFile);
      formData.append("intro_video", this.introVideo);
      formData.append("intro_audio", this.introAudio);
      formData.append("cover_letter", this.coverLetter);
      formData.append("internel_notes", this.internelNotes);
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/job-seeker-get-cvs`, formData)
        .then((res) => {
          this.cancel();
          this.getInititalData();
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        })
        .catch(() => {
          this.loading = false;
          this.submitting = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    viewButtonClick(path) {
      window.open(this.MEDIA_URL + path);
    },
    updateCV() {
      if (this.cvTitle == "") {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      this.submitting = true;
      let formData = new FormData();
      formData.append("cv_title", this.cvTitle);
      formData.append("intro_video", this.introVideo);
      formData.append("intro_audio", this.introAudio);
      formData.append("cover_letter", this.coverLetter);
      formData.append("internel_notes", this.internelNotes);
      if (this.cvFile !== "") {
        formData.append("cv_file", this.cvFile);
      }

      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/job-seeker-get-cvs/${this.cvId}`, formData)
        .then((res) => {
          this.cancel();
          this.getInititalData();
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        })
        .catch(() => {
          this.loading = false;
          this.submitting = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    changeStatus(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/job-seeker-set-cv-default/${item.id}`)
        .then((res) => {
          this.loading = false;
          this.success = true;

          Swal.fire({
            title: "",
            text: "Status updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    editButtonClick(item) {
      this.createForm = false;
      this.updateForm = true;
      this.cvTitle = item.cv_title;
      this.cvId = item.id;
      this.introVideo = item.intro_video;
      this.introAudio = item.intro_audio;
      this.internelNotes = item.internel_notes;
      this.coverLetter = item.cover_letter;
      this.cV_APP = item;
      this.alwyes = false;
    },

    deleteButtonClick(item) {
      JobSeekerService.deleteMyCv(item)
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel();
        })
        .catch(() => {
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.loading = false;
        });
    },
    CVArchive(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/cv-archive/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "CV has been updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },

    deleteItem() {
      this.deleteButtonClick(this.deleteId);
    },
  },

};
</script>

<style >
.container {
  max-width: none !important;
}

.circular--portrait {
  position: relative;
  overflow: hidden;
  border-radius: 50%;
}
</style>